import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorIndividualHubs from "@travily/types/pages/FoundingMemberCreatorIndividualHubs";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { FoundingMemberIndividualHubsStepView } from "./show.view";

type FormData = {
  individual_profile: {
    hubs_experience: string | null;
    hubs_worked: string;
  };
};

const EXPERIENCE_FIELD = "individual_profile.hubs_experience";
const WORKED_FIELD = "individual_profile.hubs_worked";

const HubsStep = ({ stage_index, stage_order, individual_profile }: FoundingMemberCreatorIndividualHubs) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("individual", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "hubs",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: {
        individual_profile: {
          hubs_experience: individual_profile.hubs_experience ?? null,
          hubs_worked: individual_profile.hubs_worked ?? "",
        },
      },
    });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.individual.hubs.show.meta_title")}>
        <meta
          name="description"
          content={t("web.founding_members.creator.steps.individual.hubs.show.meta_description")}
        />
      </Head>
      <FoundingMemberIndividualHubsStepView
        experienceValue={form.data.individual_profile.hubs_experience}
        workedValue={form.data.individual_profile.hubs_worked}
        error={fieldError(EXPERIENCE_FIELD)}
        currentStage={currentStage}
        totalStages={totalStages}
        primaryPending={primaryPending}
        topBarActions={topBarActions}
        onBack={onBack}
        onPrimary={onPrimary}
        onExperienceChange={(value) => {
          form.setData(EXPERIENCE_FIELD, value);
          validate(EXPERIENCE_FIELD);
        }}
        onWorkedChange={(value) => form.setData(WORKED_FIELD, value)}
      />
    </>
  );
};

export default HubsStep;
